import { makeAutoObservable } from 'mobx'

export class CheckboxStore {
  allIds: number[] = []
  selectedIds: number[] = []
  isAllChecked: boolean = false
  isIndeterminate: boolean = false
  status: number | null = null
  reportStatus: number | null = null
  toReportFirstEl: any | null = null //только для создания отчета!!! не использовать просто так!
  toReportAllIds: number[] = []
  isForbiddenPaymentType: boolean = false // для групповой операции добавления в архив
  forbiddenPaymentCounts: number = 0
  // подразумевается что для перехода просмотра деталей сущности во время набора сущностей на групповую операцию
  forbidResetSelectedIds: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setAllIds = (
    ids: number[],
    withResetAllIds?: boolean,
    isArchive?: boolean,
  ) => {
    this.isForbiddenPaymentType = false
    if (isArchive) {
      const hasSelected = ids.some((id) => this.selectedIds.includes(id))
      if (!hasSelected) {
        this.resetAll(true)
      } else {
        this.selectedIds = this.selectedIds.filter((id) => ids.includes(id))

        if (this.selectedIds.length === ids.length) {
          this.isAllChecked = true
          this.isIndeterminate = false
        } else {
          this.isAllChecked = false
          this.isIndeterminate = true
        }
      }
    } else if (!this.forbidResetSelectedIds) {
      this.resetAll(withResetAllIds)
    } else {
      setTimeout(() => {
        this.forbidResetSelectedIds = false
      }, 50)
    }

    this.allIds = ids
  }

  setToReportFirstEl = (el: any) => {
    this.toReportFirstEl = el
    if (el) {
      this.selectedIds = [el.id]
    }
  }

  partialDeleteIds = (ids: number[]) => {
    this.allIds = this.allIds.filter((id) =>
      this.status === 1 ? !ids.includes(id) : !!id,
    )
    this.selectedIds = this.selectedIds.filter((id) => !ids.includes(id))

    this.isIndeterminate =
      !!this.selectedIds.length &&
      this.selectedIds.length !== this.toReportAllIds.length

    this.isAllChecked = this.selectedIds.length === this.allIds.length
  }

  setForbiddenPaymentCount = (
    value: 'increment' | 'decrement' | 'set',
    count?: number,
  ) => {
    if (value === 'increment') {
      this.forbiddenPaymentCounts = this.forbiddenPaymentCounts + 1
    } else if (value === 'set' && count) {
      this.forbiddenPaymentCounts = count
    } else {
      if (this.forbiddenPaymentCounts - 1 <= 0) {
        this.isForbiddenPaymentType = false
        this.forbiddenPaymentCounts = 0
      } else {
        this.forbiddenPaymentCounts = this.forbiddenPaymentCounts - 1
      }
    }
  }

  setIsForbiddenPaymentType = (value: boolean) => {
    this.isForbiddenPaymentType = value
    if (value) {
      this.forbiddenPaymentCounts = 1
    }
  }

  setToReportAllIds = (ids: number[]) => {
    this.toReportAllIds = ids
    this.isIndeterminate =
      !!this.selectedIds.length && this.toReportFirstEl
        ? this.selectedIds.length !== this.toReportAllIds.length
        : this.selectedIds.length !== this.allIds.length

    this.isAllChecked =
      !!this.selectedIds.length && this.toReportFirstEl
        ? this.selectedIds.length === this.toReportAllIds.length
        : this.selectedIds.length === this.allIds.length
  }

  toggleSelectId = (
    id: number,
    status: number | null = null,
    reportStatus: number | null = null,
  ) => {
    if (this.selectedIds.includes(id)) {
      this.selectedIds = this.selectedIds.filter((selectId) => selectId !== id)
    } else {
      this.selectedIds = [...this.selectedIds, id]
    }

    if (!this.status) {
      this.status = status
      this.reportStatus = reportStatus
    } else if (!this.selectedIds.length && this.status) {
      this.status = null
      this.reportStatus = reportStatus
    }

    const defaultIsIndeterminate =
      !!this.selectedIds.length &&
      this.selectedIds.length !== this.allIds.length

    this.isIndeterminate =
      !!this.selectedIds.length && this.toReportFirstEl
        ? this.selectedIds.length !== this.toReportAllIds.length
        : defaultIsIndeterminate

    const defaultIsAllChecked =
      !!this.selectedIds.length &&
      this.selectedIds.length === this.allIds.length

    this.isAllChecked =
      !!this.selectedIds.length && this.toReportFirstEl
        ? this.selectedIds.length === this.toReportAllIds.length
        : defaultIsAllChecked

    if (!this.isIndeterminate && !this.isAllChecked) {
      setTimeout(() => {
        this.toReportFirstEl = null
      }, 0)
    }
  }

  updateSelectedIds = (ids: number[], selected: number[], id?: number) => {
    this.allIds = ids
    if (id) {
      this.selectedIds = selected.includes(id)
        ? selected.filter((el) => el !== id)
        : [...selected, id]
    } else if (ids.some((id) => selected.includes(id))) {
      this.selectedIds = selected.filter((id) => ids.includes(id))
    } else {
      this.selectedIds = []
    }

    this.isIndeterminate =
      !!this.selectedIds.length &&
      this.selectedIds.length !== this.allIds.length

    this.isAllChecked =
      !!this.selectedIds.length &&
      this.selectedIds.length === this.allIds.length

    if (!this.isIndeterminate && !this.isAllChecked) {
      setTimeout(() => {
        this.toReportFirstEl = null
      }, 0)
    }
  }

  // для фыормирования отчета где все чекбоксы не должны сбрасываться
  updateSelectedIdsForCreated = (ids: number[]) => {
    this.allIds = ids
    if (this.isAllChecked) {
      this.selectedIds = Array.from(new Set([...this.selectedIds, ...ids]))
    }
  }

  toggleAllSelection = (status: number, reportStatus: number) => {
    if (this.isAllChecked) {
      setTimeout(() => {
        this.toReportFirstEl = null
      }, 0)
      this.isAllChecked = false
      this.selectedIds = []
      this.status = null
      this.reportStatus = null
      this.forbiddenPaymentCounts = 0
      this.isForbiddenPaymentType = false
    } else {
      this.isAllChecked = true
      this.isIndeterminate = false
      this.selectedIds = this.allIds

      if (!this.status) {
        this.status = status
        this.reportStatus = reportStatus
      }
    }
  }

  setForbidResetSelectedIds = (value: boolean) => {
    this.forbidResetSelectedIds = value
  }

  resetAll = (withResetAllIds?: boolean) => {
    this.selectedIds = []
    this.isIndeterminate = false
    this.status = null
    this.reportStatus = null
    this.isForbiddenPaymentType = false
    this.forbiddenPaymentCounts = 0

    if (withResetAllIds) {
      this.isAllChecked = false
      this.toReportFirstEl = null
    }
  }
}

const checkboxStore = new CheckboxStore()

export default checkboxStore
